import React, { ReactElement } from 'react';
import GridInternal from '@mui/material/Grid';
import FormatService from '../../services/format-service';
import useStylesGrid from './grid.styles';

const Grid: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const WIDTH_LARGE: number = 3;
  const WIDTH_SMALL: number = 1;

  const {
    isEnd,
    isSpread,
    isCentered,
    isStretched,
    withLargeSpacing,
    withSmallSpacing,
    className,
    children,
  } = props;

  const { classes } = useStylesGrid();

  const stretchedClassName: string | undefined = isStretched ? classes.gridStretched : undefined;
  const spreadClassName: string | undefined = isSpread ? classes.gridSpread : undefined;
  const centeredClassName: string | undefined = isCentered ? classes.gridCentered : undefined;
  const endClassName: string | undefined = isEnd ? classes.gridEnd : undefined;

  const largeSpacingSize: number | undefined = withLargeSpacing ? WIDTH_LARGE : undefined;
  const smallSpacingSize: number | undefined = withSmallSpacing ? WIDTH_SMALL : undefined;

  return (
    <GridInternal
      container
      spacing={largeSpacingSize || smallSpacingSize}
      className={FormatService.formatClassNames(
        stretchedClassName, spreadClassName, centeredClassName, endClassName, className,
      )}
    >
      {children}
    </GridInternal>
  );
});

export default Grid;
